module.exports = __webpack_public_path__ + "img/BoyGirlFrame1.8acf50aa.png";